import React, { Component } from 'react';
import Prismic from 'prismic-javascript';
import { PrismicConfig } from '../../../../../helpers/prismicHelpers/PrismicAPI';
import { prismicSliceHelper, prismicSliceContentRelationship } from '../../../../../helpers/prismicHelpers/prismic-slice-helpers/PrismicSliceHelpers';
import { sliceComponentsHelper } from '../../../../../helpers/prismicHelpers/prismic-slice-helpers/SliceComponentsHelpers';
import Loader from '../../../../common/elements/Loader';
import { siteOfOriginHelper } from '../../../../../helpers/genericHelpers';
import { LanguagePrismicHelper } from '../../../../../helpers/prismicHelpers/PrismicHelpers';

class EventsPage extends Component {
	state = {
		slices: null,
	};

	async componentDidMount() {
		//prismic
		const prismicConnection = await Prismic.api(PrismicConfig.apiEndpoint, {
			accessToken: PrismicConfig.apiAccessTokes,
		});
		const json = await prismicConnection.query(
			Prismic.Predicates.at('my.flexible-layout.uid', 'events-page'), LanguagePrismicHelper());
		let { slices } = prismicSliceHelper(json);
		slices =
			slices && slices.length
				? await prismicSliceContentRelationship(slices, prismicConnection)
				: null;
		this.setState({ slices });
	}

	shouldComponentUpdate(nextProps, nextState) {
		return this.state.slices !== nextState.slices;
	}

	render() {
		const { slices } = this.state;

		if (!slices) return <Loader />;

		return (
			<div className="container-fluid events-page">
				{sliceComponentsHelper(slices)}
			</div>
		);
	}
}

export default EventsPage;



// WEBPACK FOOTER //
// src/client/components/site/features/events/pages/EventsPage.js